/**
* The fallback API error message.
* @type {String}
**/
export const GENERIC_SERVER_ERROR_MESSAGE = 'layout.global_messages.user_activation.errors.server_error';

/**
* The error message translations key to show when the user email is empty.
* @type {String}
**/
export const EMAIL_IS_EMPTY = 'layout.global_messages.user_activation.errors.email.empty';

/**
* The error message translations key to show when the user email is invalid.
* @type {String}
**/
export const EMAIL_IS_INVALID = 'layout.global_messages.user_activation.errors.email.invalid';

/**
* The <UserActivation/> component UI modes, to be toggled according to interactions..
* @type {Object<String>}
**/
export const UI_MODES = {
    DEFAULT: 'default',
    EDIT: 'edit',
    LOADING: 'loading',
    SUBMITTED: 'submitted'
};

/**
* A list of supported email providers. Used by LinkProvider to allow user to open their inbox in a new tab
* @type {Object<String>}
**/
export const EMAIL_DOMAIN_PROVIDERS = {
    'gmail.com': 'gmail.com',
    'hotmail.com': 'hotmail.com',
    'yahoo.com': 'mail.yahoo.com',
    'outlook.com': 'outlook.com',
    'aol.com': 'mail.aol.com',
    'live.com': 'live.com',
    'hotmail.co.uk': 'hotmail.co.uk',
    'me.com': 'me.com',
    'ymail.com': 'ymail.com',
    'yahoo.co.uk': 'mail.yahoo.co.uk',
    'msn.com': 'outlook.com',
    'hotmail.fr': 'hotmail.fr',
    'icloud.com': 'icloud.com',
    'mail.ru': 'e.mail.ru',
    'googlemail.com': 'googlemail.com',
    'rocketmail.com': 'rocketmail.com',
    'mail.com': 'mail.com/mail',
    'yahoo.co.id': 'mail.yahoo.co.id',
    'live.co.uk': 'live.co.uk'
};

/**
 * The supported events the <UserActivation/> component emits.
 * @type {Object<String>}
 */
export const EVENT_TYPES = {
    CONTACT_SUPPORT: 'contact_support',
    EDIT_CLICKED: 'edit_clicked',
    UPDATE_EMAIL_SUBMIT: 'update_email_submit',
    SUBMIT: 'submit',
    INBOX_LINK: 'inbox_link',
    TAX_PROFILE_LINK: 'tax_profile_link'
};

/**
 * Holds the event type to tracking platform data mapping.
 * @type {Object<String>}
 */
export const EVENTS = {
    [EVENT_TYPES.CONTACT_SUPPORT]: {
        bigQuery: 'activation_banner_contact_support',
        mixpanel: 'activation banner - contact support',
        grafana: 'action.contact_support'
    },
    [EVENT_TYPES.EDIT_CLICKED]: {
        bigQuery: 'activation_banner_change_email',
        mixpanel: 'activation banner - change email',
        grafana: 'action.change_email'
    },
    [EVENT_TYPES.UPDATE_EMAIL_SUBMIT]: {
        bigQuery: 'activation_banner_update_email_resend',
        mixpanel: 'activation banner - update email resend',
        grafana: 'action.update_email_resend'
    },
    [EVENT_TYPES.SUBMIT]: {
        bigQuery: 'activation_banner_resend',
        mixpanel: 'activation banner - resend email',
        grafana: 'action.resend'
    },
    [EVENT_TYPES.INBOX_LINK]: {
        bigQuery: 'activation_banner_inbox_link',
        mixpanel: 'activation banner - inbox link',
        grafana: 'action.inbox_link'
    }
};
